import { QueryClient, type QueryObserverOptions } from 'react-query';

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  });

/**
 * @deprecated access queryClient using useQueryClient hook (DO NOT IMPORT THIS DIRECTLY)
 */
export let queryClient: QueryClient = createQueryClient();

export const setGlobalQueryClient = (newQueryClient: QueryClient) => {
  queryClient = newQueryClient;
};

export const staleTime = (2 * 60 * 1000) satisfies QueryObserverOptions['staleTime'];
